import React from "react";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import CheckboxSettingSection from "Signups/FamilyRegistration/Shared/CheckboxSettingSection";
import EmailDropdown from "Signups/FamilyRegistration/Shared/Dropdown/EmailDropdown";
import ErrorMessage from "Signups/FamilyRegistration/Shared/ErrorMessage";
import useFamilyRegistrationAdminPermissions from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";

export default function CompletionNote() {
  const { state } = useFamilyRegistrationContext();
  const { updateSetting, error } = useUpdateSetting();

  const { shouldDisableFamilyRegistrationSettings } =
    useFamilyRegistrationAdminPermissions();

  let availableUsers =
    state?.familyRegistrationSettings?.completionNote?.availableUsers || [];
  const selectedUserID =
    state?.familyRegistrationSettings?.completionNote?.selectedUserID;

  async function onSelect(userID) {
    await updateSetting({
      setting: "completionNote",
      itemID: userID,
      value: "fullName",
    });
  }

  return (
    <CheckboxSettingSection
      setting="completionNote"
      label="Enable members to add a note upon registration completion. Notes will be emailed to:"
      disabled={shouldDisableFamilyRegistrationSettings}
    >
      <div style={{ maxWidth: "360px" }}>
        <EmailDropdown
          nameKey="fullName"
          idKey="userID"
          placeholder={"Select a user"}
          options={availableUsers}
          onSelect={onSelect}
          label="Email"
          initialSelectedId={selectedUserID}
        />
      </div>

      <ErrorMessage error={error?.error} marginLeft="0px" />
    </CheckboxSettingSection>
  );
}
